<template>
  <div class="worder-summary-box" :style="{height:contentHeight+'px'}">
    <div class="worder-summary-list" v-if="model.transferList && model.transferList.length" ref="scrollDiv">
      <div class="worder-summary-item" v-for="(item,idx) in model.transferList">
        <img class="worder-summary-avatar" v-if="item.type!=7" @click="huifu(item.createBy,item.isMineCreate)" :src="getAvatarView(item.createByAvatar || 'https://oss.dimoclub.com/static/driver/defalut_icon.png')"/>
        <img class="worder-summary-avatar" v-else src="https://oss.dimoclub.com/static/driver/default_logo.png"/>
        <div class="worder-summary-item-content">
          <div class="a-to-b">
            <span style="font-size: 16px;color: #000;cursor: pointer" v-if="item.type!=7" @click="huifu(item.createBy,item.isMineCreate)">{{item.createByName}}</span>
            <span style="font-size: 16px;color: #000;" v-else>系统</span>
            <span v-if="item.type==1">转交给了</span>
            <span v-if="item.type==2">结束了工单</span>
            <span v-if="item.type==3">重启了工单</span>
            <span v-if="item.type==4">挂起了工单</span>
            <span v-if="item.type==5">完成了工单</span>
            <span v-if="item.type==6">验收了工单</span>
            <span v-if="item.type==7">回收了工单</span>
            <span v-if="item.type==0">创建了工单</span>
            <span v-if="item.type==1" style="font-size: 16px;color: #000;cursor: pointer" @click="huifu(item.transfer,item.isMineTransfer)">{{item.transferName}}</span>
            <span>{{item.createTime}}</span>
            <span class="worder-summary-item-time">
              <img src="@/assets/driver/time_hui.png"/>
              <span style="vertical-align: middle;">{{returnCallTime(item.createTime,(idx==model.transferList.length-1?null:model.transferList[parseInt(idx)+1].createTime))}}</span>
            </span>
          </div>
          <div class="worder-summary-item-msg" v-if="item.remark">{{item.remark}}</div>
          <div class="worder-summary-item-imgs" v-if="item.imageFile" >
            <img class="worder-summary-item-img-item" @click="viewImg(a)" :src="getAvatarView(a)" v-for="a in item.imageFile.split(',')"/>
          </div>
          <div class="worder-summary-item-imgs" v-if="item.videoUrl">
            <!--<Video :width="300" :height="225" :ref="'veo'+ind"    v-for="(b,ind) in item.videoUrl.split(',')"  @click="viewVideo" style="margin-top: 10px;" @stop="stopAll" :idx="ind"  :videoUrl="b"-->
            <!--&gt;</Video>-->
            <div  class="video-fm" @click="bfVideo(b)" v-for="(b,ind) in item.videoUrl.split(',')">
               <img  src="@/assets/driver/video-bf.png"/>
            </div>
          </div>
          <div :class="item.downloading?'batch_downloading':'batch_download'" v-if="checkDownload(item)" @click="dbDownload(item)">{{item.downloading?'正在下载中...':'打包下载'}}</div>
          <!--<a-button  type="link" v-if="checkDownload(item)" @click="dbDownload(item)">打包下载</a-button>-->
        </div>
      </div>
      <div ref="viewer" class="images" v-viewer="viewerOptions" style="display: none;">
        <img :src="previewImage" :key="previewImage">
      </div>
      <video-tan ref="videoTan" @close="visible=false" :visible="visible" :videoUrl="videoUrl"></video-tan>
  </div>

    <div class="operate-worder" v-if="model.workOrderStatus==1 || model.workOrderStatus==4">
      <div class="worder-btn" v-if="model.workOrderStatus==1"><a @click="showTemplate" style="position: absolute;margin-left: -29%">业务模板</a>当前进度：{{model.transferName}} 待处理<span>{{djs}}</span></div>
      <div class="worder-btn" v-if="model.workOrderStatus==4"><a @click="showTemplate" style="position: absolute;margin-left: -29%">业务模板</a>当前进度：{{model.transferName}} 挂起中<span>{{djs}}</span></div>
    </div>
    <template-modal ref="templateModal" :dictOptions="dictOptions"></template-modal>
  </div>

</template>

<script>

  import { httpAction, getAction,getFileAccessHttpUrl ,deleteAction,downloadFile} from '@/api/manage'
  import {initDictOptions, filterDictText} from '@/components/dict/JDictSelectUtil'
  import { returnCallTimeEng ,returnCallTime} from '@/utils/util'
  import { BatchDownloadFile } from '@/mixins/BatchDownloadFile'
  import VideoTan from "../../video/VideoTan";
  import TemplateModal from "@comp/dm/workorder/modal/TemplateModal.vue";

  export default {
    inject:['closeCurrent'],
    name: 'WorkOrderMessage',
    mixins:[BatchDownloadFile],
    components: {
      TemplateModal,
      VideoTan

    },
    props: {
      model:{
        type:Object,
        default:{}
      },
      dictOptions:{
        type:Object,
        default:{}
      }
    },data(){
      return {
        contentHeight:document.documentElement.clientHeight-300,
        viewerOptions:{
          title: false, // 显示当前图片的标题(显示alt属性或从URL解析出的图片名称)[布尔值/数字/方法/数组：默认true]
          toolbar: true, // 显示工具栏、自定义工具栏[布尔值/数字/对象：默认true]
          movable: true, // 图片是否可移动[布尔值：默认true]
          zoomable: true, // 图片是否可缩放[布尔值：默认true]
          url: 'src' // 播放时图片地址 URL 来源。[字符串/方法：默认src](如果是字符串，则应该是每个图像元素的属性之一。 如果是方法，则应该返回一个有效的图像URL)
        },
        previewVisible:false,
        previewImage:"",
        returnCallTimeEng:returnCallTimeEng,
        returnCallTime:returnCallTime,
        djs:'',
        videoUrl: "",
        visible: false,
      }
    },methods:{
      getAvatarView(url){
        return getFileAccessHttpUrl(url)
      },viewImg(url){
        this.previewImage = this.getAvatarView(url);
        this.$refs.viewer.$viewer.show();
      },getDjs(){
        this.djs =  returnCallTime(this.model.transferList[this.model.transferList.length-1].createTime,null);
        let that = this;
        setTimeout(function(){
          that.getDjs();
        },1000);
      },remark(){
        let record = {
          ids:this.model.id,
          type:4,
          workOrderStatus:4
        }
        this.$emit("editWorkOrder",record);
      },huifu(transfer,isMine){
        if(isMine){
          this.remark();
        }else{
          let record = {
            ids:this.model.id,
            type:1,
            transfer:transfer
          }
          this.$emit("editWorkOrder",record);
        }

      },zj(){
        let record = {
          ids:this.model.id,
          type:1,
          workOrderStatus:1
        }
        this.$emit("editWorkOrder",record);
      },back(){
        let formData = {
          id:this.model.id
        };
        httpAction("/dm/dmWorkOrder/backOrder",formData,"POST").then((res)=>{
          if(res.success){
            this.$emit("change",1);
            this.$message.success(res.message);
          }else{
            this.$message.warning(res.message);
          }
        })
      },toBottom(){
        this.$nextTick(() => {
          let scrollElem = this.$refs.scrollDiv;
          scrollElem.scrollTo({ top:scrollElem.scrollHeight, behavior: 'smooth' });
        });
      },bfVideo(v){
        //this.$refs.videoTan.view(v);
        this.visible = true;
        this.videoUrl = v;
      },checkDownload(tr){
         let imageFile = tr.imageFile;
         let num = 0;
         if(imageFile){
           num += imageFile.split(",").length;
         }
         if(tr.videoUrl){
           num += tr.videoUrl.split(",").length;
         }
         return num > 1;
      },dbDownload(tr){
        if(tr.downloading){
          return;
        }
        tr.downloading = true;
        let fileList = []
        let imageFile = tr.imageFile;
        if(imageFile){
          for(let a in imageFile.split(",")){
            let image = imageFile.split(",")[a];
            // fileList.push({
            //   originalName:image.substring(image.lastIndexOf("/")+1),
            //   url:getFileAccessHttpUrl(image)
            // });
            fileList.push(getFileAccessHttpUrl(image))
          }
        }

        if(tr.videoUrl){
          for(let a in tr.videoUrl.split(",")){
             let video = tr.videoUrl.split(",")[a];
              // fileList.push({
              //   originalName:video.substring(video.lastIndexOf("/")+1),
              //   url:getFileAccessHttpUrl(video)
              // })
            fileList.push(getFileAccessHttpUrl(video))
          }
        }
        this.fileList = fileList;
        this.blogTitle = this.model.driverName+"-工单附件打包.zip";
        downloadFile("/sys/common/zipDownload",this.blogTitle,{imageUrls:this.fileList.join(","),name:this.blogTitle}).then(res=>{
          tr.downloading = false;
        }).finally(res=>{
          console.log("打包下载完成")
          tr.downloading = false
        })
      },showTemplate(){
        this.$refs.templateModal.show(this.model.businessSegment,this.model.id);
      }
    }
  }
</script>
<style lang="less" scoped>
  .worder-summary-box{
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding-bottom: 16px;
  }
  .worder-summary-list{
    flex: 1;
    padding: 24px;
    overflow-y: auto;
  }
  .worder-summary-item{
    display: flex;
    margin-bottom: 32px;
  }
  .worder-summary-avatar{
    height: 40px;
    width: 40px;
    border-radius: 50%;
    background-color: #ccc;
  }
  .worder-summary-item-content{
    margin-left: 24px;
    width: 624px;
  }
  .a-to-b{
    height: 40px;
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .worder-summary-item-msg{
    padding: 2px;
    width: 624px;
    font-size: 16px;
    white-space: pre-wrap;
  }
  .worder-summary-item-imgs{
    display: flex;
    flex-wrap: wrap;
    padding: 10px 0;
    gap: 40px;
  }
  .worder-summary-item-img-item{
    width: 120px;
    height: 120px;
    border-radius: 12px;
    background: #E8F1FF;
  }
  .worder-summary-item-time{
    padding: 12px;
  }

  .worder-summary-item-time img{
    width: 16px;
    height: 16px;
    margin-right: 9px;
  }


  .worder-btn{
    height: 48px;
    border-radius: 12px;
    background: rgba(232, 241, 255, 1);
    box-shadow: 0px 1px 2px  rgba(184, 200, 224, 0.22);
    font-size: 16px;
    color: rgba(125, 133, 146, 1);
    text-align: center;
    line-height: 48px;
    cursor: pointer;
    margin:0 24px;
    position: relative;
  }
  .worder-btn span {
    color: rgba(63, 140, 255, 1);
    margin-left: 10px;
  }
  .video-fm{
    width: 160px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    background: #000;
    cursor: pointer;
  }

  .video-fm img{
    width: 50px;
  }
  .batch_download{
    color: #1890FF;
    cursor: pointer;
  }
  .batch_downloading{
    color: #aaa;
    cursor: pointer;
  }
</style>